import MARKDOWN from "@/legal/master-terms.md?raw";
import LegalShell from "./_LegalShell";
import LegalMarkdown from "./_LegalMarkdown";
import { LEGAL_HASH, LEGAL_UPDATED } from "@/legal/version";

export default function Terms() {
  return (
    <LegalShell
      title="Business Terms of Service"
      updated={LEGAL_UPDATED}
      canonicalPath="/terms"
    >
      <p
        style={{
          margin: "0 0 24px",
          fontFamily: "monospace",
          fontSize: 11,
          overflowWrap: "anywhere",
          color: "#766b5d",
        }}
      >
        SHA-256 {LEGAL_HASH}
      </p>
      <LegalMarkdown markdown={MARKDOWN} />
    </LegalShell>
  );
}
